// extracted by mini-css-extract-plugin
export default {"fadeInUp":"FadeInSection_fadeInUp__R37ut","active":"FadeInSection_active__b1JbA"};